import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ListNumbers } from "@phosphor-icons/react";

export function TopRoomsToday() {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/validations/top-rooms-today?limit=3");
        if (!cancelled) setRooms(data);
      } catch (err) {
        console.error("Failed to load top rooms:", err);
      }
    };
    load();
    const interval = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  if (rooms.length === 0) return null;

  return (
    <Card className="bg-card border-border rounded-sm shadow-none" data-testid="top-rooms-today">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-sm font-semibold text-foreground flex items-center gap-2 uppercase tracking-wider">
          <ListNumbers size={16} weight="bold" className="text-[#007AFF]" />
          Top 3 Rooms Today
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="grid grid-cols-[1fr_auto_auto] gap-0">
          {/* Header */}
          <div className="px-4 py-1.5 text-[10px] uppercase tracking-[0.15em] text-muted-foreground font-semibold border-b border-border">#</div>
          <div className="px-4 py-1.5 text-[10px] uppercase tracking-[0.15em] text-muted-foreground font-semibold border-b border-border">Room Number</div>
          <div className="px-4 py-1.5 text-[10px] uppercase tracking-[0.15em] text-muted-foreground font-semibold border-b border-border text-right">Validation Count</div>
          {/* Rows */}
          {rooms.map((r, i) => (
            <div key={r.room_number} className="contents">
              <div className="px-4 py-2 font-mono-data text-xs text-muted-foreground border-b border-border">{i + 1}.</div>
              <div className="px-4 py-2 font-mono-data text-sm text-foreground border-b border-border">Room {r.room_number}</div>
              <div className="px-4 py-2 font-mono-data text-sm font-semibold text-[#007AFF] text-right border-b border-border">{r.count}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
